import React from 'react';
import { useChat } from '../../contexts/ChatContext';

const EmptyConversation: React.FC = () => {
  const { sendMessage } = useChat();
  
  // Example questions for users to try
  const allExampleQuestions = [
            "Analyze the Ocean and Inland Business performance of Sabic from Q3 2024 till Q2 2025",
            "Compare the Ocean and Inland business between FMCG,Retail and Technology verticals in H1 2025",
            "For the Top 5 Trades on the East-West Market in Q3 2025, what is the share of Inland business when compared with Ocean",
            "For Top 3 customers by Inland Revenue in 2025, Provide a breakdown of their Inland financials by Export & Import",
            "What are the top five destination countries by shipment count?",
            "How many active shipments are there for Nike?",
            "Can you tell me about the customers in the lifestyle segment?",
            "What is the carrier haulage ratio across all our shipments in Q2-2025?",
            "What is the average actual cost for dry cargo shipments?",
            "What is the distribution of our largest customers?",
            "Where is most of our cargo coming from?",
            "Who are the customers in the US-China trade with the highest absolute margins?"
          ];
  
  // Show all questions in development, only first 3 in production
  const exampleQuestions = process.env.NODE_ENV === 'development' 
    ? allExampleQuestions 
    : allExampleQuestions.slice(0, 4);
  
  return (
    <div className="h-full flex items-center justify-center text-center">
      <div className="text-center p-8 max-w-2xl"> 
        <div className="mx-auto w-18 h-18 bg-neutral dark:bg-dark-secondary rounded-full flex items-center justify-center mb-4 hover-glow-lg">
          <img src="/maersk-line-lego.png" alt="Shipment CoCaptain Logo" className="w-16 h-16" />
          {/* <FiMessageCircle size={32} className="text-text-tertiary dark:text-dark-textSecondary" /> */}
        </div>
          {/* <div className="text-primary text-5xl mb-4">👋</div> */}
        <h2 className="text-3xl font-extralight mb-2 text-text-primary dark:text-dark-text">
          Welcome to <span className="font-extrabold bg-clip-text text-transparent bg-[linear-gradient(to_right,theme(colors.primary.800),theme(colors.primary.DEFAULT),theme(colors.primary.200),theme(colors.primary.DEFAULT),theme(colors.primary.800))] bg-[length:200%_auto] animate-gradient-sweep-text">Shipment CoCaptain</span>
          {/* Welcome to <span className="font-extrabold bg-clip-text text-transparent bg-[linear-gradient(to_right,theme(colors.primary.50),theme(colors.primary.200),theme(colors.primary.400),theme(colors.primary.600),theme(colors.primary.800))] bg-[length:200%_auto] animate-gradient">Shipment CoCaptain</span> */}
          {/* Welcome to <span className="font-extrabold bg-clip-text text-transparent bg-[linear-gradient(to_right,theme(colors.primary.200),theme(colors.primary.DEFAULT),theme(colors.primary.800),theme(colors.primary.DEFAULT),theme(colors.primary.200))] bg-[length:200%_auto] animate-gradient">Shipment CoCaptain</span> */}
          {/* Welcome to <span className="font-bold bg-gradient-to-r from-primary-light to-primary-dark bg-clip-text text-transparent animate-gradient">Shipment CoCaptain</span> */}
          {/* Welcome to <span className='font-bold text-primary'>Shipment CoCaptain</span> */}

        </h2>
        <p className="text-text-secondary dark:text-dark-textSecondary mb-6">
          Ask questions about our shipments, analyze data, or get insights about our operations.
        </p>
        <div className="space-y-4">
          <p className="text-xl font-medium text-text-primary dark:text-dark-text">Try asking:</p>
          <div className="text-center space-y-2"> 
            {/* text-left */}
            {/* <div className="grid grid-cols-1 mx-3 md:mx-0 md:grid-cols-2 gap-3 max-w-2xl"> */}
            {exampleQuestions.map((question, index) => (
              <button
                key={index}
                onClick={() => sendMessage(question)}
                className="w-full max-w-lg p-3 text-left bg-white dark:bg-dark-secondary border border-neutral-dark dark:border-dark-border rounded-xl text-text-secondary dark:text-dark-textSecondary hover:text-text-primary dark:hover:text-dark-text transition-colors hover-glow-xl"
              >
                {question}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyConversation;
